import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { TemplateOne } from "./templates/one";

function App() {
  return <TemplateOne />;
}

export default App;
